function init_pakketten() {
    $('.alle-pakketten .cpx-button').on('click', function() {
        show_loading_screen();
    });

    $('.alle-pakketten__quicknav .cpx-button').each(function() {
        var $button = $(this);
        $button.on('click', function() {
            var target = $button.attr('data-quicknav-link');

            var $target_el = $('#'+target);
            if($target_el) {
                $("html, body").animate({
                    scrollTop: ($target_el.offset().top - 100)
                }, 500, function() {
                    hide_loading_screen();
                });
            }
        });
    });
}

$(document).ready(function() {
    init_pakketten();
});